/* ────────────────────────────────────────────────────────────
   Nuey Popup Form
   - Triggers (delay / scroll / exit / manual)
   - Suppression (session / visitor / always; permanent for submitters)
   - ESC + click-outside + close-button dismissal
   - Auto-closes 6s after HubSpot form-submitted

   NOTE: HubSpot embed script is loaded inside the section liquid file,
   not from here. That's intentional — lazy-loading the embed broke
   submission delivery to HubSpot.
   ──────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  function initPopup(root) {
    if (!root || root.dataset.popupInit === '1') return;
    root.dataset.popupInit = '1';

    var overlay     = root.querySelector('.popupFormOverlay');
    var closeBtn    = root.querySelector('.popupFormClose');
    var triggerType = root.dataset.trigger || 'delay';
    var delayMs     = (parseFloat(root.dataset.delay) || 5) * 1000;
    var scrollPct   = parseFloat(root.dataset.scrollPct) || 40;
    var maxShows    = parseInt(root.dataset.maxShows || '2', 10);
    var storageKey  = root.dataset.storageKey || ('nuey-popup-' + root.id);

    function alreadySubmitted() {
      // Permanent suppression — lives in localStorage forever once they submit.
      try { return !!window.localStorage.getItem(storageKey + '-submitted'); }
      catch (e) { return false; }
    }

    function getSessionShowCount() {
      // Count of times the popup has appeared in THIS session.
      // sessionStorage clears when the browser session ends, so this resets
      // on the visitor's next visit.
      try {
        var n = parseInt(window.sessionStorage.getItem(storageKey + '-count') || '0', 10);
        return isNaN(n) ? 0 : n;
      } catch (e) { return 0; }
    }

    function alreadyShown() {
      // Submitters: never show again (lifetime, localStorage).
      if (alreadySubmitted()) return true;
      // Non-submitters: show up to maxShows times per session (resets on
      // next visit). 0 = unlimited.
      if (maxShows > 0 && getSessionShowCount() >= maxShows) return true;
      return false;
    }

    function markSubmitted() {
      try { window.localStorage.setItem(storageKey + '-submitted', Date.now()); }
      catch (e) {}
    }

    function markShown() {
      // Per-session counter. Resets when the browser session ends.
      try {
        var n = getSessionShowCount() + 1;
        window.sessionStorage.setItem(storageKey + '-count', String(n));
      } catch (e) {}
    }

    function open() {
      if (root.classList.contains('is-open')) return;
      if (alreadyShown()) return;

      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      // Strip the inline visibility/pointer-events hint — CSS takes over now
      root.style.visibility = '';
      root.style.pointerEvents = '';
      document.documentElement.classList.add('popup-form-locked');
      document.body.classList.add('popup-form-locked');

      // Focus the close button for a11y, but DON'T let it scroll the page.
      setTimeout(function () {
        if (!closeBtn) return;
        try { closeBtn.focus({ preventScroll: true }); }
        catch (e) { closeBtn.focus(); }
      }, 50);

      markShown();
    }

    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('.popupFormSection.is-open')) {
        document.documentElement.classList.remove('popup-form-locked');
        document.body.classList.remove('popup-form-locked');
      }
    }

    // ── Triggers ────────────────────────────────────────────
    if (triggerType === 'delay') {
      setTimeout(open, delayMs);
    } else if (triggerType === 'scroll') {
      var fired = false;
      var onScroll = function () {
        if (fired) return;
        var scrolled = window.scrollY + window.innerHeight;
        var totalH   = document.documentElement.scrollHeight;
        var pct      = (scrolled / totalH) * 100;
        if (pct >= scrollPct) {
          fired = true;
          window.removeEventListener('scroll', onScroll);
          open();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    } else if (triggerType === 'exit') {
      var exitFired = false;
      document.addEventListener('mouseout', function (e) {
        if (exitFired) return;
        if (e.clientY <= 0 && !e.relatedTarget) {
          exitFired = true;
          open();
        }
      });
    }
    // 'manual' trigger: call window.openNueyPopup() from elsewhere

    window.openNueyPopup = open;
    window['openNueyPopup_' + root.id] = open;

    // ── Close handlers ──────────────────────────────────────
    closeBtn && closeBtn.addEventListener('click', close);

    overlay && overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    // When HubSpot form is submitted: mark as permanently suppressed, then
    // close the modal after a brief delay so HubSpot's built-in thank-you
    // message flashes before disappearing.
    window.addEventListener('message', function (event) {
      if (!event.data) return;
      var d = event.data;
      if (d.type === 'hsFormCallback' && d.eventName === 'onFormSubmitted') {
        markSubmitted();
        setTimeout(close, 2500);
      }
    });

  }

  function initAll() {
    var nodes = document.querySelectorAll('.popupFormSection');
    for (var i = 0; i < nodes.length; i++) initPopup(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var node = e.target && e.target.querySelector('.popupFormSection');
    if (node) initPopup(node);
  });
})();